var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-cascader", {
            staticStyle: { width: "200px" },
            attrs: {
              clearable: "",
              options: _vm.buildingOptions,
              props: _vm.propstree,
              placeholder: "请先选择楼栋"
            },
            on: { change: _vm.checkSelectBuild },
            model: {
              value: _vm.listQuery.upIdList,
              callback: function($$v) {
                _vm.$set(_vm.listQuery, "upIdList", $$v)
              },
              expression: "listQuery.upIdList"
            }
          }),
          _c("el-input", {
            staticStyle: { width: "200px" },
            attrs: {
              clearable: "",
              type: "text",
              placeholder: "请输入客户名称"
            },
            model: {
              value: _vm.listQuery.customerName,
              callback: function($$v) {
                _vm.$set(_vm.listQuery, "customerName", $$v)
              },
              expression: "listQuery.customerName"
            }
          }),
          _c("el-date-picker", {
            attrs: {
              format: "yyyy - MM- dd",
              "value-format": "yyyy-MM-dd",
              type: "daterange",
              "range-separator": "至",
              "start-placeholder": "接房开始日期",
              "end-placeholder": "接房结束日期"
            },
            model: {
              value: _vm.dates,
              callback: function($$v) {
                _vm.dates = $$v
              },
              expression: "dates"
            }
          }),
          _c(
            "el-button",
            {
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter }
            },
            [_vm._v(_vm._s(_vm.$t("button.search")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", icon: "el-icon-plus" },
              on: { click: _vm.deliveryRegistration }
            },
            [_vm._v("接房登记")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", icon: "el-icon-download" },
              on: { click: _vm.handleUpload }
            },
            [_vm._v(_vm._s(_vm.$t("button.export")))]
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.list,
            "element-loading-text": "数据正在加载中...",
            border: "",
            stripe: "",
            fit: "",
            "highlight-current-row": ""
          },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: _vm.$t("table.id"), width: "50" }
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "小区名称" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.areaName))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "楼栋" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.buildingName))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "房间代码" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "link-type",
                        on: {
                          click: function($event) {
                            return _vm.getRoomDetail(scope.row.houseId)
                          }
                        }
                      },
                      [_vm._v(_vm._s(scope.row.houseCode))]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "建筑面积" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.houseArea
                      ? _c("span", [_vm._v(_vm._s(scope.row.houseArea))])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "客户名称" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "link-type",
                        on: {
                          click: function($event) {
                            return _vm.getCustomerDetail(scope.row.customerId)
                          }
                        }
                      },
                      [_vm._v(_vm._s(scope.row.customerName))]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "接房日期" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.statusDate))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: _vm.$t("table.actions"),
              "class-name": "small-padding fixed-width",
              width: "190px"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "mini",
                          plain: "",
                          icon: "el-icon-edit"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleUpdate(scope.row)
                          }
                        }
                      },
                      [_vm._v("编辑")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.listQuery.page,
              "page-sizes": [10, 20, 30, 50],
              "page-size": _vm.listQuery.limit,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogFormVisible,
            width: "800px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c("delivery-add", {
            attrs: {
              "delivery-obj": _vm.deliveryData,
              "show-dialog": _vm.dialogFormVisible
            },
            on: { handCancle: _vm.handCancle }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogHouseFormVisible,
            width: "920px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogHouseFormVisible = $event
            }
          }
        },
        [
          _c("house-detail", {
            attrs: {
              "key-value": _vm.houseId,
              "show-dialog": _vm.dialogHouseFormVisible
            },
            on: { handCancle: _vm.handCancle }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogCustomerFormVisible,
            width: "920px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogCustomerFormVisible = $event
            }
          }
        },
        [
          _c("customer-detail", {
            attrs: {
              "key-value": _vm.customerId,
              "show-dialog": _vm.dialogCustomerFormVisible
            },
            on: { handCancle: _vm.handCancle }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }